<template>
  <div class="card">
    <div class="card-content">
      <h1 class="title is-spaced">Help</h1>
      <h2 class="subtitle">How to add the signature to Gmail</h2>
      <div class="content">
        <ul>
          <li>After setting up the signature, click "Copy to Clipboard"</li>
          <li>Open Gmail</li>
          <li>In the top right corner, click Settings</li>
          <li>In the Signature section, paste the signature</li>
          <li>Click "Save Changes"</li>
        </ul>
      </div>
      <h2 class="subtitle">Troubleshooting</h2>
      <div class="content">
        <ul>
          <li><strong>The signature doesn't look the same when I pasted it into Gmail</strong> - Clear the contents of the Signature text box, save the changes, open Settings and paste the signature again.</li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'HelpModal'
}
</script>